exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\npicture {\n  padding-top: 5px;\n}\n", ""]);

// exports
